module.exports = __webpack_public_path__ + "static/media/portrait_07.06aeddd9.jpg";